<template>
  <!-- eslint-disable max-len -->
  <div
    v-if="appName === 'Zu-MAP'"
    class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">放送二次使用料分配サービス(レコード製作者)利用規約</h3>
    </div>
    <div class="page-block__inner">
      <div
        class="terms-area">
        <div class="terms-text__box">
          <p>
            本放送二次使用料分配サービス(レコード製作者)利用規約（以下「本利用規約」といいます。）は、株式会社massenextが提供する放送二次使用料分配サービスの著作隣接権(レコード製作者)の利用に関する諸条件を定めるものです。本サービス（第1条で定義します。）の利用を希望される方は、本利用規約をよくお読み頂き、全てに同意の上ご利用下さい。本サービスの登録を利用された場合、本利用規約の全ての記載内容に承諾したものとみなされます。本利用規約に同意いただけない場合、本サービスを利用することはできません。<br><br>
            本サービスのご利用に際しては、本利用規約並びに当社との間で利用者が別途締結した音楽配信許諾基本契約書等その他の契約、規約（以下併せて「関連規約」といいます。）が適用されます。当社ウェブサイトに掲載される本利用規約及び関連規約の最新版を、随時ご確認ください。本利用規約と関連規約が矛盾抵触する場合は、関連規約が優先して適用されるものとします。<br>
          </p>
        </div>

        <h4>第１条：定義</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>「当社」とは、株式会社massenextをいいます。</li>
            <li>「本サービス」とは、当社が本利用規約及び関連規約に基づき提供する放送二次使用料分配サービス(レコード製作者)をいいます。</li>
            <li>「アカウント」とは、本サービスを利用するために必要な仮想口座「Zu-MAPアカウント」をいいます。アカウントは、アカウント管理者ごとに開設され、管理レコード放送二次使用料（第5条で定義します。）その他のアカウント管理者等が受領権限を有する金額をプラス計上し、手数料その他当社が収受すべき金額をマイナス計上します。なお、アカウントの残高には利息はつきません。</li>
            <li>「アカウント管理者」とは、本利用規約に同意の上、本サービスへの登録の申込をされた方であって、当社が当該申込を承諾した方をいいます。なお、本サービス上において、「管理者」と表記する場合があります。</li>
            <li>「アカウント管理者等」とは、アカウント管理者とアカウントメンバーの総称をいいます。</li>
            <li>「コンテンツ」とは、アカウント管理者が本サービスに登録又は提供（アップロードを含む）した楽曲・歌詞を含む音楽作品をいいます。</li>
            <li>「二次使用料を受ける権利に関する指定団体」とは、著作権法（昭和45年5月6日法律第48号）に定義される指定団体をいいます。</li>
          </ol>
        </div>

        <h4>第２条：本サービス</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本サービスの一環として、アカウント管理者は自身の管理画面において管理レコード放送二次使用料を確認することができます。</li>
            <li>本サービスは、日本語を十分に理解し読み書きができる、日本国内在住の個人又は日本国内に事業拠点を有する法人を対象とします。</li>
            <li>アカウント管理者等は、以下の事項を表明・保証します。本サービスの提供は、これらの表明・保証が全て正確かつ真実であること、及びアカウント管理者が本利用規約を遵守することを条件とします。</li>
            <ul>
              <li>(1)アカウント管理者等が、本サービスの登録・利用を行うために必要な、完全な権利及び権限を有すること。</li>
              <li>(2)アカウント管理者等が、日本国内在住の個人又は日本国内に事業拠点を有する法人であること。</li>
              <li>(3)本利用規約に従ったアカウント管理者等による本サービスの登録・利用（支払の受領、及び利用の停止・中止を含みます。以下本条において同じです。）、並びに、本サービスに係るコンテンツの利用（当社及びそのライセンシー及び利用者による利用を含みます。以下本条において同じです。）が、法令及びアカウント管理者等と第三者とのいかなる契約その他の合意にも抵触せず、違反又は債務不履行を構成しないこと。</li>
              <li>(4)アカウント管理者以外にコンテンツの放送二次使用料(レコード製作者)を受ける権利（著作権法97条に定める権利のことをいう。以下同じ。）を持つ者（アカウントメンバーを含みます。）がいる場合、アカウント管理者は当該放送二次使用料(レコード製作者)を受ける権利を持つ者から、本利用規約に従ったアカウント管理者による本サービスの登録・利用、並びに本サービスに係るコンテンツの利用に必要な、一切の授権を取得済みであること。</li>
              <li>(5)アカウント管理者等が本利用規約に基づき、又は本サービスに関連して提供する情報は、全て正確であること。</li>
            </ul>
          </ol>
        </div>

        <h4>第３条：放送二次使用料(レコード製作者)を受ける権利登録</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>アカウント管理者は、音楽配信許諾基本契約書に基づくアカウント登録をおこなった上で、当社の審査を経て承認された場合にのみ、当該コンテンツは放送二次使用料分配サービス(レコード製作者)利用規約に基づいて当社に放送二次使用料(レコード製作者)を受ける権利が譲渡され、本サービスの対象となります。なお、本サービスの利用停止については、別途当社にお問い合わせください。</li>
            <li>アカウント管理者は、コンテンツが二次使用料を受ける権利に関する指定団体等の定める条件に合致しない場合、その他当社が不適当と判断した場合に、当社が当該コンテンツの登録を承認しないことを了承するものとします。</li>
            <li>アカウント管理者は、第1項に従い登録された各コンテンツにつき、本サービス利用の対価として、当社が定める登録管理手数料を支払います。登録管理手数料の詳細は、放送二次使用料分配サービス(レコード製作者)利用規約（本規約第6条）によるものとします。</li>
          </ol>
        </div>

        <h4>第４条：コンテンツについて</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>アカウント管理者は、当社及び当社から許諾された第三者が本サービスの提供に関連して（コンテンツの販売促進及び本サービスの広告宣伝を含みます）、コンテンツに含まれる情報等を無償で使用することを了承するものとします。</li>
            <li>アカウント管理者は、当社及び当社から許諾された第三者に対して、自ら又は第三者（アカウントメンバーを含みます。）をして著作者人格権を行使しないことに同意するものとします。</li>
            <li>アカウント管理者は、登録又は提供するコンテンツに関し、当社に対し以下を保証するものとします。</li>
            <ul>
              <li>(1)コンテンツに関する放送二次使用料(レコード製作者)を受ける権利について、正当な権利者であること、又は、正当な権利者から本サービスに係るコンテンツの放送二次使用料(レコード製作者)を受ける権利の譲渡を受けていること。</li>
              <li>(2)本サービスに係るコンテンツの利用が、第三者の著作権・レコード製作者の権利（放送二次使用料を受ける権利を含む。以下同じ。）・著作隣接権・肖像権その他一切の権利を侵害しないこと。</li>
            </ul>
            <li>アカウント管理者は、コンテンツに関して当社に対して第三者から異議・苦情等の申立又は損害賠償等の請求があった場合には、自らの責任と費用負担において処理するものとし、当社に一切損害を発生させないものとします。</li>
            <li>アカウント管理者等は、本サービスを利用したことに起因して（当社がかかる利用を原因とするクレームを第三者より受けた場合を含みます。）、当社が直接的又は間接的に何らかの損害（弁護士費用の負担を含みます。）を被った場合、当社の請求に従って直ちにこれを賠償しなければなりません。</li>
            <li>アカウント管理者等は、本サービスを、当該サービスを通じた放送二次使用料を受ける権利(レコード製作者)管理の目的のみに利用するものとし、それ以外の目的（当社以外による同種又は類似サービスの開発・検討等を含みます）に本サービス（当該サービスを通じて得られるデータ、ノウハウ等を含みます）を利用することは禁止します。また、本サービス利用期間中及びその後1年間、本サービスと競合するサービスを開発又は競合するサービスに従事することを目的として利用、解析等を行うことも禁止されます。これらの禁止行為を行った場合は本利用規約違反となり、当社は直ちに当該サービス又はアカウントの利用停止・中止、当該サービスの利用契約の解除その他必要と認める措置及び損害賠償請求を行うことができるものとします。</li>
          </ol>
        </div>

        <h4>第５条：管理レコード放送二次使用料等</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>管理レコード放送二次使用料とは、当社が登録されたコンテンツに関し、二次使用料(レコード製作者)を受ける権利に関する指定団体等の報告等に基づき受領したレコード放送二次使用料の金額から所定の登録管理手数料を差し引いた金額をいいます。なお、当社はかかるレコード放送二次使用料が二次使用料を受ける権利に関する指定団体等から任意に支払われない場合、これを取立あるいは回収する義務を負わないものとします。</li>
            <li>当社は、二次使用料を受ける権利に関する指定団体等の報告等に基づき受領したレコード放送二次使用料を、収入の根拠となる管理レコード放送二次使用料明細をアカウント管理者に報告した上で、アカウント管理者が当社所定の方法であらかじめ登録した銀行口座に振込みにより支払うこととします。なお、レコード放送二次使用料に1円未満の端数がある場合、当社はアカウントに計上しないことができます。</li>
            <li>前項につき、当社は、１年分のレコード放送二次使用料を、年に一度、７月末にアカウント管理者に収入の根拠となる管理レコード放送二次使用料明細を報告した上で、８月末にアカウント管理者が当社所定の方法であらかじめ登録した銀行口座に振込む方法により支払うものとします。なお、振込みに必要な銀行手数料は、当社が負担するものとします。</li>
            <li>アカウント管理者は、二次使用料を受ける権利に関する指定団体等において、管理レコード放送二次使用料の過払い額その他の調整が行われる場合があることを了承するものとします。この場合、当社は、アカウント管理者のアカウント残高から調整額を差し引くものとし、アカウント管理者はこれを了承するものとします。</li>
            <li>アカウント管理者が支払いを受けた管理レコード放送二次使用料は、アカウント管理者の責任と負担において、その他の正当な権利者へ配分するものとします。当社は、アカウント管理者に支払った後の管理レコード放送二次使用料の配分について一切の責任を負いません。</li>
          </ol>
        </div>

        <h4>第６条：放送二次使用料(レコード製作者)を受ける権利の譲渡</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>コンテンツの放送二次使用料(レコード製作者)を受ける権利の管理を行うことを目的として、アカウント管理者は、コンテンツの放送二次使用料(レコード製作者)を受ける権利を、本規約の諸条項に従い、本規約に基づく放送二次使用料(レコード製作者)を受ける権利譲渡の有効期間中、当社に対し独占的に譲渡します。</li>
            <li>アカウント管理者は、当社に対し、コンテンツが製作者（アカウント管理者が当社に届け出た製作者をいいます）の創作による完全なレコードであること、本規約に従い放送二次使用料(レコード製作者)を受ける権利を譲渡するために必要かつ充分な権利及び能力を保有していることを保証します。また、アカウント管理者は、コンテンツの放送二次使用料(レコード製作者)を受ける権利に関し現在または将来なんら不利な要求が第三者より起こらないこと、及び万一そのような事態が生じた場合には、第三者からの一切の要求に対し、責任をもってこれを措置し、当社になんらの支障・損害を与えないことを保証します。</li>
            <li>地域及び期間について次の通り定めます。</li>
            <ul>
              <li>(1)本規約に基づき、アカウント管理者が当社に対して譲渡する放送二次使用料を受ける権利の譲渡地域は、日本国内のみとします。</li>
              <li>(2)本規約に基づく放送二次使用料を受ける権利譲渡の有効期間は、コンテンツのそれぞれにつき、当社の審査及び承認により当該コンテンツの放送二次使用料を受ける権利譲渡が効力を生じた日から起算して3年間とします。</li>
              <li>(3)前項の期間満了の2ヵ月前までにアカウント管理者または当社の一方から他方に対し、当社所定の方式で反対の意思表示がなされない限り、放送二次使用料を受ける権利譲渡の有効期間は自動的に3年間延長されるものとします。その後の延長についても同様とします。</li>
            </ul>
            <li>譲渡の範囲について次の通り定めます。</li>
            <ul>
              <li>(1)本規約に基づき、アカウント管理者が当社に対して譲渡する放送二次使用料(レコード製作者)を受ける権利は、著作権法第97条に規定する権利を含むものとします。</li>
              <li>(2)当社は、コンテンツに関し、前項に定める権利を排他的に行使できるものとします。</li>
              <li>(3)本配信契約者は、当社がコンテンツの移転の登録を行うに必要な一切の事項に関し、当社に対し協力義務を負うものとします。なお、期間満了または解除により放送二次使用料(レコード製作者)を受ける権利譲渡が終了した場合には、当社は、本配信契約者に対し同様の協力義務を負うものとします。</li>
            </ul>
            <li>当社は、コンテンツの放送二次使用料(レコード製作者)を受ける権利について、管理を一般社団法人日本レコード協会（以下「レコード協会」といいます）に委託します。</li>
            <li>当社は、コンテンツの複製物に当社が指定するレコード製作者の権利表示を行い、または行わせることができるものとします。</li>
            <li>管理手数料について次の通り定めます。</li>
            <ul>
              <li>(1)アカウント管理者は当社に対し、本サービスの管理手数料として、コンテンツが、本規約に基づきレコード協会に管理を委託している区分で第三者により利用された場合において、当社が当該利用につきレコード協会から受領した放送二次使用料の額（以下「レコード協会管理収益」といいます。）と要した費用を控除した金額の15％相当額（諸税別）を、支払うものとします。</li>
              <li>(2)前号の管理手数料の支払は、当社がレコード協会管理収益をアカウント管理者のアカウントに計上する時に管理手数料を控除する方法によるものとし、当該控除後の残額は、アカウント管理者が取得するものとします。</li>
            </ul>
            <li>当社は、本規約の履行の状況に関して、アカウント管理者から請求を受けた場合には、本規約その他の関連規約の定めに従い、アカウント管理者に説明するものとします。</li>
            <li>第三者への権利譲渡等について次の通り定めます。</li>
            <ul>
              <li>(1)当社は、アカウント管理者の同意を得ない限り、第三者（レコード協会を除きます。）へのコンテンツの放送二次使用料を受ける権利の売却・譲渡等の処分を行ってはならないものとします。但し、当社が営業譲渡をし、吸収・合併され、または会社分割する場合、その放送二次使用料を受ける権利が他に移転するときはこの限りでないものとします。</li>
              <li>(2)前号但書によりコンテンツの放送二次使用料(レコード製作者)を受ける権利が他に移転する場合には、当社は、当該移転前にアカウント管理者に対し移転先、移転予定日、移転理由、その他必要な事項を当社所定の方法により通知するものとします。但し、経営上の秘密その他やむを得ない事由により、移転前に通知ができなかった場合には、移転後速やかに同様の通知を行うものとします。</li>
            </ul>
            <li>解除等について次の通り定めます。</li>
            <ul>
              <li>(1)当社が、破産の宣告もしくは会社の解散決議のいずれかに該当した場合には、本規約に基づく放送二次使用料を受ける権利譲渡は、解除されたものとみなします。</li>
              <li>(2)アカウント管理者は、当社が営業活動を廃止した場合、または当社の本店及び営業所の所在がいずれも不明である場合には、本規約に基づく放送二次使用料(レコード製作者)を受ける権利譲渡を解除することができるものとします。</li>
              <li>(3)アカウントが削除その他により失効した場合、及びアカウント管理者に対する本サービスの提供が中止・停止その他により失効した場合、本規約に基づく放送二次使用料を受ける権利譲渡は、解除されたものとみなします。</li>
            </ul>
            <li>期間満了または解除により本規約に基づく放送二次使用料(レコード製作者)を受ける権利譲渡が失効した場合には、コンテンツの放送二次使用料(レコード製作者)を受ける権利は、当然アカウント管理者に帰属するものとします。</li>
            <li>当社は、相続、法人の合併、会社分割等によりアカウント管理者の権利の承継者が新たに生じた場合であっても、当該承継者から権利を証する文書を添えた承継の通知を受けた上で、当社所定の手続によりアカウントの変更または新規開設等の手続を完了しない限り、本規約に基づくアカウント管理者への放送二次使用料(レコード製作者)を受ける権利収益を従前のアカウント管理者のアカウントに計上し、または、当社が適当と認めるところに従い保管することができるとし、これにより本規約に基づく債務不履行の責任を負わないものとします。</li>
            <li>アカウント管理者・当社の両当事者またはその一方が、放送二次使用料(レコード製作者)を受ける権利に関する指定団体と委託契約を締結している場合には、アカウント管理者及び当社は、当該委託契約を尊重します。但し、アカウント管理者・当社間の関係においては、すべて本規約の定めるところに従うものとします。</li>
          </ol>
        </div>

        <h4>第７条：本サービスの中止、停止</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、以下のいずれかの事由が発生した場合には、本サービスの全部又は一部の提供を停止することができるものとします。その場合、当社の裁量によりアカウントを凍結することができます。</li>
            <ul>
              <li>(1)設備等のメンテナンスを行う場合。</li>
              <li>(2)天災地変等の不可抗力の場合。</li>
              <li>(3)通信回線の障害等の事故があった場合。</li>
              <li>(4)法令等により本サービスの提供ができない場合。</li>
              <li>(5)その他当社が必要と判断した場合。</li>
            </ul>
            <li>前項にかかわらず、当社は、原則として3ヶ月前までにアカウント管理者等に通知することにより、本サービスの提供を中止することができるものとします。その場合、当社の裁量によりアカウントを抹消することができます。</li>
            <li>当社は、本サービスの全部又は一部の提供の停止又は中止に起因してアカウント管理者が被った損害について、一切の責任を負いません。</li>
          </ol>
        </div>

        <h4>第８条：業務の委託</h4>
        <div class="terms-text__box">
          <li>当社は、本サービスの一部を当社が選定した第三者に委託することができるものとします。</li>
        </div>

        <h4>第９条：規約の変更</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本利用規約は、当社の判断により事前の通知なく随時変更を行うことができるものとします。</li>
            <li>本利用規約を変更する場合、当社はその旨を変更後の規約の内容及び変更の効力発生日とともに、本サービスに係る当社所定のウェブサイト上に掲示し、又はアカウント管理者等に通知するものとします。アカウント管理者等はかかる掲示ないし通知を定期的に確認するものとします。</li>
            <li>本利用規約の変更後に、本サービスを利用することにより、アカウント管理者等は変更後の利用規約の全ての記載内容を承諾したものとみなされます。</li>
          </ol>
        </div>

        <h4>第１０条：準拠法・管轄裁判所</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本利用規約は日本法に基づいて解釈されるものとします。</li>
            <li>本サービス及び本利用規約に起因し、又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
          </ol>
        </div>

        <p>本利用規約は2025年5月1日より実施します。</p>
        <p>2025年5月1日制定</p>

        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'index' }"
            class="c-btn c-btn--back">
            トップへ戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
    <!-- eslint-enable max-len -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'ZuMapSecondaryUsageFeeForBroadcastsCopyright',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>

<style lang="scss" scoped>
  ol.numbered{
    margin-left: 1.2em;
    & > li{
    list-style: decimal;
      }
  }
</style>
